import { render, staticRenderFns } from "./ModalInviteAdmin.vue?vue&type=template&id=51ecc184&"
import script from "./ModalInviteAdmin.vue?vue&type=script&lang=js&"
export * from "./ModalInviteAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ModalInviteAdmin.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ecc184')) {
      api.createRecord('51ecc184', component.options)
    } else {
      api.reload('51ecc184', component.options)
    }
    module.hot.accept("./ModalInviteAdmin.vue?vue&type=template&id=51ecc184&", function () {
      api.rerender('51ecc184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/globals/ModalInviteAdmin.vue"
export default component.exports